/**
 * Retrieves the styleguide's text colours by name
 * @param {string} color - A string of the color to return
 * @return {string} Returns the CSS class for the associated color
 */

import getColorClass from '../getColorClass'
import { Color } from '../getColorClass/types'

function getTextColorClass (color = 'black') {

  switch (color) {

    case 'orange':
      return getColorClass(Color.task, 'color')
    case 'white':
      return getColorClass(Color.white, 'color')
    case 'black': default:
      return getColorClass(Color.primary, 'color')
    case 'darkOrange':
      return getColorClass(Color.darkOrange, 'color')

  }

}

export default getTextColorClass
